<script setup lang="ts">
import type { WikiItem } from "~~/types/gamedata";

const props = defineProps<{ item: WikiItem }>();

const image = computed(() => props.item.images?.[0]?.thumbnail_url ?? props.item.images?.[0]?.original_url ?? null);
</script>

<template>
  <div class="flex flex-col overflow-hidden rounded-lg bg-bunker-950 ring-1 ring-white/10">
    <div class="relative aspect-video overflow-hidden bg-woodsmoke-900">
      <img
        v-if="image"
        :src="image"
        :alt="item.name"
        loading="lazy"
        class="h-full w-full object-cover"
      >
      <div v-else class="flex h-full items-center justify-center">
        <UIcon name="i-lucide-paintbrush" class="size-8 text-primary/50" />
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-1 p-3">
      <h3 class="!my-0 truncate text-sm font-semibold text-white">
        {{ item.name }}
      </h3>
      <p v-if="item.manufacturer?.name" class="!my-0 truncate text-xs text-neutral-400">
        {{ item.manufacturer.name }}
      </p>
    </div>
  </div>
</template>
